import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from "@angular/router";

import { SwiperModule } from "swiper/angular";

import { LocalizationModule } from "src/core/index/shared.module.index";

import { FullCalendarModule } from "@fullcalendar/angular";

import {
    AdvancedSearchComponent, CalendarComponent, ChatTogglerComponent, ClickOutsideDirective, ContentDetailComponent,
    ContentPreviewComponent, CourseCertificateComponent, CourseDetailComponent, CoursePreviewComponent,
    DropdownComponent, FooterComponent, GuideDetailComponent,
    GuidePreviewComponent, HandleImgErrorDirective, HandleStringObjectPipe, IconComponent,
    LanguageSelectorComponent, LoadingComponent, ModalComponent, ModalMessageComponent, PaginationComponent,
    PopupComponent, RouterLinkDirective, SanitizePipe, SidebarComponent, SuggestedCoursesComponent,
    TeacherDetailComponent, UserMenuComponent,
} from 'src/index/components.index';
import { NgxFloatUiModule } from "ngx-float-ui";

@NgModule({
    declarations: [
        AdvancedSearchComponent,
        CalendarComponent,
        ChatTogglerComponent,
        ClickOutsideDirective,
        ContentDetailComponent,
        ContentPreviewComponent,
        CourseCertificateComponent,
        CourseDetailComponent,
        CoursePreviewComponent,
        DropdownComponent,
        FooterComponent,
        GuideDetailComponent,
        GuidePreviewComponent,
        HandleImgErrorDirective,
        HandleStringObjectPipe,
        IconComponent,
        LanguageSelectorComponent,
        LoadingComponent,
        ModalComponent,
        ModalMessageComponent,
        PaginationComponent,
        PopupComponent,
        RouterLinkDirective,
        SanitizePipe,
        SidebarComponent,
        SuggestedCoursesComponent,
        TeacherDetailComponent,
        UserMenuComponent,
    ],
    imports: [
        BrowserModule,
        CommonModule,
        FormsModule,
        LocalizationModule,
        RouterModule,
        SwiperModule,
        FullCalendarModule,
        NgxFloatUiModule,
    ],
    providers: [
    ],
    exports: [
        AdvancedSearchComponent,
        CalendarComponent,
        ChatTogglerComponent,
        ClickOutsideDirective,
        ContentDetailComponent,
        ContentPreviewComponent,
        CourseCertificateComponent,
        CourseDetailComponent,
        CoursePreviewComponent,
        DropdownComponent,
        FooterComponent,
        GuideDetailComponent,
        GuidePreviewComponent,
        HandleImgErrorDirective,
        HandleStringObjectPipe,
        IconComponent,
        LanguageSelectorComponent,
        LoadingComponent,
        LocalizationModule,
        ModalComponent,
        ModalMessageComponent,
        PaginationComponent,
        PopupComponent,
        RouterLinkDirective,
        SanitizePipe,
        SidebarComponent,
        SuggestedCoursesComponent,
        TeacherDetailComponent,
        UserMenuComponent,
    ],
})
export class SharedModule {
}
